import { isValid } from "date-fns/esm";
import { TabView, TabViewProps } from "primereact/tabview";
import React, { useEffect } from "react";
import styled from "styled-components";
import { concatClassnames } from "../../WSUtils/util";
import { device } from "../../WSUtils/constants/mediaQueries";
import { useRerenderWhenBodyResize } from "../../WSUtils/useRerenderWhenBodyResize";

// The CvpTabView component can only take in PrimeReact <TabPanel/> components as children.

const CvpTabView: React.FC<TabViewProps> = ({
  children,
  className,
  ...otherProps
}) => {
  useRerenderWhenBodyResize();

  return (
    <StyledTabView
      className={concatClassnames(["cvp-tab-view", className])}
      {...otherProps}
    >
      {children}
    </StyledTabView>
  );
};

export default CvpTabView;

export const StyledTabView = styled(TabView)`
  &.cvp-tab-view {
    &.p-tabview {
      .p-tabview-nav {
        border-bottom-width: 2px;
      }

      .p-tabview-nav .p-tabview-ink-bar {
        z-index: 1;
        display: block;
        position: absolute;
        bottom: 0;
        height: 2px;
        transition: 500ms cubic-bezier(0.35, 0, 0.25, 1);
        background: var(--primary-500);
      }

      .p-tabview-nav .p-tabview-nav-link {
        border-top: none;
        border-left: none;
        border-right: none;
        background: transparent;
        color: inherit;
        margin: 0 0 -4px 0;
      }

      .p-tabview-nav li .p-tabview-nav-link {
        border-width: 4px;
        font-size: 0.9rem;

        @media ${device.lg} {
          font-size: 1rem;
        }
      }

      .p-tabview-nav
        li:not(.p-highlight):not(.p-disabled):hover
        .p-tabview-nav-link {
        background: transparent;
        border-color: transparent;
      }

      .p-tabview-nav .p-tabview-nav-link {
        justify-content: center;
      }

      .p-tabview-panels {
        background: transparent;
      }

      @media ${device.lg} {
      }
    }
  }
`;
